export const OBSERVE_LANGUAGE = 'language';
